import PropTypes from "prop-types";
import styles from "./index.css";
import classnames from "classnames";

const ProductDiscount = ({ discount, className }) => (
  <div
    aria-hidden={true}
    className={classnames(styles.productDiscount, className)}
  >{`-${discount}%`}</div>
);

ProductDiscount.propTypes = {
  discount: PropTypes.number.isRequired,
  className: PropTypes.string
};

export default ProductDiscount;
